import { defineMessages } from 'react-intl';

export default defineMessages({
    notValidReasonToRemoveDriver: {
        id: 'ml.policychange.MLVehicleOperatorStatusComponent.The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver.'
    },
    spouseCannotBeRemovedIfLicensed: {
        id: 'ml.policychange.MLVehicleOperatorStatusComponent.Spouse cannot be removed as a driver if licensed',
        defaultMessage: 'Spouse cannot be removed as a driver if licensed.'
    },
    notValidReasonToRemoveNamedInsured: {
        id: 'ml.policychange.MLVehicleOperatorStatusComponent.The reason selected is not a valid reason to remove the named insured. We require this person to be listed',
        defaultMessage: 'The reason selected is not a valid reason to remove the named insured. We require this person to be listed.'
    },
    notValidReasonToRemoveSecondaryNamedInsured: {
        id: 'ml.policychange.MLVehicleOperatorStatusComponent.The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed',
        defaultMessage: 'The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed.'
    },
    notValidReasonToRemoveHouseholdMember: {
        id: 'ml.policychange.MLVehicleOperatorStatusComponent.The reason selected is not a valid reason to remove this household member',
        defaultMessage: 'The reason selected is not a valid reason to remove this household member.'
    }
});
